import React from 'react';
import { Button, Flex, Heading, Text } from 'rebass';
import Field from 'components/Field';
import Link from 'components/Link';
import ErrorMessage from 'components/ErrorMessage';
import colors from 'theme/colors';
import Form from 'components/Form';
import { startForgotPasswordSubmit, resolveForgotPasswordSubmit } from '../actions';
import FORGOTPASSWORD from '../content';

const ForgotPasswordForm: React.FC = (): JSX.Element => (
  <Form
    startSubmitAction={startForgotPasswordSubmit().type}
    resolveSubmitAction={resolveForgotPasswordSubmit().type}
  >
    {(formProps: any) => {
      const { form, submitting, submitErrors, submitSucceeded } = formProps;
      return (
        <>
          {submitSucceeded ? (
            <Heading fontSize={['36px']} textAlign="center" mt={7}>
              {FORGOTPASSWORD.heading.submitSucceededText}
            </Heading>
          ) : (
            <Flex flexDirection="column" alignItems="center" py={7} px={4}>
              {submitErrors && <ErrorMessage>{submitErrors.data.error.message}</ErrorMessage>}
              <Heading fontSize={['36px']} textAlign="center" mb={5}>
                {FORGOTPASSWORD.heading.title}
              </Heading>
              <Text
                fontSize="26px"
                fontWeight={5}
                textAlign="center"
                mb={6}
                css="max-width: 740px;"
              >
                {FORGOTPASSWORD.heading.subtitle}
              </Text>
              <Field name="email" label="Email" inputType="email" required />
              <Button
                variant={submitting ? 'disabled' : 'primary'}
                mt={2}
                mb={3}
                onClick={form.submit}
                disabled={submitting}
              >
                {FORGOTPASSWORD.button}
              </Button>
              <Link to="/signin" color={colors.turquoise} hover={colors.turquoise} underline="true">
                {FORGOTPASSWORD.link}
              </Link>
            </Flex>
          )}
        </>
      );
    }}
  </Form>
);

export default ForgotPasswordForm;
